import { RelationshipMapping } from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import {
  isModelConceptRelationship,
  isModelConceptRelationshipLabel,
} from 'src/containers/ProjectDiagram/utils/data';

/** updates the data bindings on the RelationshipMapping's `to` node */
export const doRelationshipMappingUpdated =
  (mapping: RelationshipMapping) => (model: Model) => {
    model.nodeDataArray.forEach((node) => {
      if (
        isModelConceptRelationshipLabel(node) &&
        node.value === mapping.relationshipIri
      ) {
        model.updateTargetBindings(node);
      }
    });

    model.linkDataArray.forEach((link) => {
      if (
        isModelConceptRelationship(link) &&
        link.value === mapping.relationshipIri
      ) {
        model.updateTargetBindings(link);
      }
    });
  };
